/* eslint-disable eqeqeq */
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles((theme) => ({
  comingSoonChip: {
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `${theme.palette.weesu.light_blue} !important`,
    border: `1px solid ${theme.palette.common.white} !important`,
    marginLeft: "5px !important",
  },
}));

function ComingSoonChip() {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      label="em breve"
      className={clsx(classes.comingSoonChip)}
    />
  );
}

export default ComingSoonChip;
